import View from './view';

import { attach } from '../model/task.utils';





export default View.extend( {

    [View.event( 'Controls:file:upload-done' )](originalName, fileType, fileSemantics, uploading) {
        return attach( this.model, originalName, fileType, fileSemantics, uploading ), this.List.render();
    },

    [View.event( 'List:attachment:toggle' )](index, editable, deleted) {
        if (!editable)
            return;

        this.model.set( 'attachments', this.model.get( 'attachments' ).map( (attachment, i) => 
            i == index
                ? { ...attachment, deleted: deleted == undefined || deleted == false || deleted == 'f' }
                : attachment ) );
    },

    serialize() {
        return {
            attachments: () => this.model.get( 'attachments' )
        };
    },

    onBind(model) {
        this.listenTo( model, 'change:attachments',
            () => this.List.render() );
    },

    onUnBind(previousModel) {
        this.stopListening( previousModel );
    }, 

} );





// WEBPACK FOOTER //
// ./src/js/view/attachments.component.js